import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Yes',
        value: 'item1',
        color: COLORS.e4ImpactBlue
    },
    {
        name: 'No',
        value: 'item2',
        color: COLORS.e4ImpactOrange
    }
];

/**
 * Survey: Acceleration Program - FINAL IMPACT
 * question: Have you tried to obtain funds since you started the Wonder Acceleration Program?
 * == final
 * question8
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursWhoRequestedFundsDuringTheProgramChartCalculation = (props: any) => {
    const data = transformData.map(({name, value, color}) => ({
        name,
        color,
        y: props.finalAccelerationProgramSubmissions.filter((submission: any) => submission.question8 === value).length
    }));
    const values = transformData.map(({value}) => value);

    return getDefaultPieFormatting(
        'KPI: % of entrepreneurs who requested funds before the acceleration program',
        data,
        0,
        {},
    ) as Highcharts.Options;
}